import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme/theme';

import { isJwtExpired } from 'jwt-check-expiration';

import store from './redux/store';
import { Provider } from 'react-redux';
import axios from 'axios';
import {
  getUserBrowserStorage,
  setUserBrowserStorage,
  clearAllBrowserStorage,
} from './constants';
import Services from './services/services';

const sessionExpiredFunc = () => {
  clearAllBrowserStorage(); // <-- add your var
  alert('Session expired. Please Sign In again!');
  window.location = '/'; // <-- add your path
};

axios.interceptors.request.use(async (request) => {
  const tokens = JSON.parse(getUserBrowserStorage('togetherTokens'));

  if (request.url.toString().includes('users/refresh/')) {
  } else if (tokens) {
    try {
      const isExpired = tokens?.accessToken && isJwtExpired(tokens.accessToken);
      if (isExpired) {
        try {
          const res = await Services.tokenRefresh(tokens.refreshToken);
          if (res.data?.access) {
            const newTokens = {
              accessToken: res.data?.access,
              refreshToken: tokens.refreshToken,
            };
            setUserBrowserStorage('togetherTokens', JSON.stringify(newTokens));
          } else {
            sessionExpiredFunc();
          }
        } catch (error) {
          console.log(error, 'inside code try catch error');
        }
      } else {
        request.headers.authorization = `Bearer ${tokens?.accessToken}`;
      }
    } catch (error) {
      console.log(error, 'try catch error');
    }
  }
  return request;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (
      error.response.request.responseURL
        .toString()
        .includes('users/view-user/?userId')
    ) {
      sessionExpiredFunc();
    } else {
      return Promise.reject(error);
    }
  }
);

ReactDOM.render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Provider store={store}>
      <App />
    </Provider>
  </ThemeProvider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
